import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getCurrentYear, getInlineLoader } from "../Helpers";
import logoWorded from "../assets/logo_worded_only.png";
import { FaArrowRightLong } from "react-icons/fa6";
import { HiOutlineEnvelope, HiOutlineMapPin, HiOutlinePhone } from "react-icons/hi2";

export default function Footer() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <footer className="MainBodySection footer-modern">
      <div className="container py-5">
        <div className="row g-3">
          <div className="col-md-3 mt-5">
            <div className="footer-brand">
              <img src={logoWorded} alt="ATRIC Business Consulting Limited" className="footer-logo" width={120} />
              <p className="footer-tagline">
                Professional consulting in Management Accounting, Taxation, Internal Audit, Project Management, and Financial Management across Tanzania.
              </p>
              <button className="btn btn-primary" onClick={() => appContext.navTo({ item: "contact_us" })} type="button">
                Get In Touch <FaArrowRightLong className="ms-2" />
              </button>
            </div>
          </div>

          <div className="col-md-3 mt-5">
            <h6 className="footer-title">Quick Links</h6>
            <div className="footer-links">
              <button className="footer-link" onClick={() => appContext.navTo({ item: "home" })}>Home</button>
              <button className="footer-link" onClick={() => appContext.navTo({ item: "about_us" })}>About Us</button>
              <button className="footer-link" onClick={() => appContext.navTo({ item: "services" })}>Services</button>
              <button className="footer-link" onClick={() => appContext.navTo({ item: "contact_us" })}>Contact</button>
            </div>
          </div>

          <div className="col-md-3 mt-5">
            <h6 className="footer-title">Services</h6>
            <div className="footer-links">
              <button className="footer-link" onClick={()=>appContext.navTo({item:'services', subItem:'management-accounting'})}>Accounting</button>
              <button className="footer-link" onClick={()=>appContext.navTo({item:'services', subItem:'taxation'})}>Taxation</button>
              <button className="footer-link" onClick={()=>appContext.navTo({item:'services', subItem:'internal-audit'})}>Internal Audit</button>
              <button className="footer-link" onClick={()=>appContext.navTo({item:'services', subItem:'project-management'})}>Project Management</button>
            </div>
          </div>

          <div className="col-md-3 mt-5">
            <h6 className="footer-title">Contact Info</h6>
            <ul className="footer-contact">
              <li>
                <HiOutlinePhone className="footer-icon" />+255 (0)717 918 808
              </li> <li>
                <HiOutlinePhone className="footer-icon" />+255 +255 (0)783 000 766
              </li>
              <li>
                <HiOutlineEnvelope className="footer-icon" />info@atric.co.tz
              </li>
              <li>
                Dar es Salaam, The Tax Hub Building 2nd Floor.
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="mb-2 text-center">&copy; {getCurrentYear()} ATRIC Business Consulting Limited. All rights reserved.</p>
          <p className="mb-0 text-center small">
            Website designed by <a href="https://werenium.com" target="_blank" rel="noreferrer" className="footer-credit">Werenium Technologies</a>
          </p>
        </div>
      </div>

      <style>{`
        .footer-modern {
          background: linear-gradient(180deg, #0f172a 0%, #111827 100%);
          color: #e2e8f0;
        }

        .footer-brand {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .footer-logo {
          background: #fff;
          border-radius: 12px;
          padding: 0.5rem 0.75rem;
          width: 140px;
        }

        .footer-tagline {
          color: #cbd5f5;
          line-height: 1.6;
          margin: 0;
        }

        .footer-cta {
          background: linear-gradient(135deg, #0f766e, #14b8a6);
          color: #fff;
          border: none;
          border-radius: 999px;
          padding: 0.75rem 1.5rem;
          font-weight: 600;
          width: fit-content;
          box-shadow: 0 10px 18px -12px rgba(20, 184, 166, 0.5);
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .footer-cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 22px -12px rgba(20, 184, 166, 0.6);
        }

        .footer-title {
          color: #f8fafc;
          font-size: 1rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .footer-links {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .footer-link {
          background: none;
          border: none;
          color: #cbd5f5;
          text-align: left;
          padding: 0;
          font-size: 0.95rem;
          transition: color 0.2s ease, transform 0.2s ease;
        }

        .footer-link:hover {
          color: #fff;
          transform: translateX(4px);
        }

        .footer-contact {
          list-style: none;
          padding: 0;
          margin: 0 0 1rem 0;
          display: flex;
          flex-direction: column;
          gap: 0.6rem;
          color: #cbd5f5;
        }

        .footer-icon {
          margin-right: 0.5rem;
          color: #38bdf8;
        }

        .footer-site {
          margin: 0;
          color: #94a3b8;
        }

        .footer-bottom {
          border-top: 1px solid rgba(148, 163, 184, 0.2);
          margin-top: 2.5rem;
          padding-top: 1.5rem;
          color: #94a3b8;
        }

        .footer-credit {
          color: #e2e8f0;
          font-weight: 700;
          text-decoration: none;
        }

        .footer-credit:hover {
          text-decoration: underline;
        }

        @media (max-width: 768px) {
          .footer-logo {
            width: 120px;
          }
        }
      `}</style>
    </footer>
  );
}
